// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__Co8xo","loader":"Loader_loader__Iv4Mh","animloader":"Loader_animloader__7QxPJ"};